import { toast } from 'react-semantic-toasts';
const defaultTime = 1000;

export default class ToastUtilities {

    static error = (message, time = defaultTime) => {
        toast({
            type: 'error',
            description: message,
            time: time
        });
    }

    static success = (message, time = defaultTime) => {
        toast({
            type: 'success',
            description: message,
            time: time
        });
    }

    static info = (message, time = defaultTime) => {
        toast({
            type: 'info',
            description: message,
            time: time
        });
    }

    static warning = (message, time = defaultTime) => {
        toast({
            type: 'warning',
            description: message,
            time: time
        });
    }
}